import { Box } from '../../primitives';
import { styled } from '../../theme';

export const Expander = styled(Box)`
	flex: 1;
`;
